<template>
  <div id="scroll">
    <div class="container">
      <el-form ref="ruleForm" :model="ruleForm" label-width="80px">
        <el-form-item label="标题" prop="title">
    <el-input v-model="ruleForm.title"></el-input>
  </el-form-item>
   <el-form-item label="排序" prop="sort">
    <el-input v-model="ruleForm.sort"></el-input>
  </el-form-item>
        <el-form-item label="所属行业">
          <el-select v-model="ruleForm.businessId" placeholder="请选择所属行业">
            <el-option
              v-for="item in BusinessList"
              v-show="item.isUsed!='true'"
              :key="item.id"
              :label="item.busName"
              :value="item.id"
            ></el-option>
          </el-select>
        </el-form-item>
      </el-form>
      <div class="editWrap">
        <editor-vue
          class="editor"
          :value="ruleForm.text"
          @input="(res) => (ruleForm.text = res)"
        >
        </editor-vue>
        <el-button @click="cancel">取 消</el-button>
        <el-button type="primary" @click="addNew()">确 定</el-button>
      </div>
    </div>
  </div>

</template>

<script>
import { getBusinessList, addIndustry, editIndustry,getIndustry } from "@/api/manage";
import editorVue from "@/components/txtModule/richText.vue";
export default {
  data() {
    return {
      ruleForm: {
        text: "",
        businessId: "",
        title:'',
        sort:''
      },
      val: "",
      isEdit: false,
      editId: "",
      BusinessList: [],
      lists:[]
    };
  },
  components: {
    editorVue,
  },

  async created() {
    let res = await  getIndustry({pageNo:1,pageSize:9999})
    this.lists=[]
    if(res.data){
      res.data.forEach(item=>{
        this.lists.push(item.businessId)
      })
    }
    this.getData();
    this.isEdit = this.$route.params.typeOf == "edit";
    this.editId = this.$route.params.id || "";
    this.ruleForm.businessId = this.$route.params.businessId || "";
    this.ruleForm.title = this.$route.params.title || "";
    this.ruleForm.sort = this.$route.params.sort || this.$route.params.total+1
    this.ruleForm.text = this.$route.params.text
      ? decodeURI(this.$route.params.text)
      : "";
  },
  methods: {
    async getData() {
      //获取行业应用列表
      let res = await getBusinessList({ pageNo: 1, pageSize: 9999 });
      if (res.code == "200") {
        this.BusinessList = res.data;
       this.BusinessList.forEach(item=>{
         if(this.lists.includes(item.id)){
           console.log('you1');
          // item.isUsed='true'
         }
       })
       console.log('this.BusinessList',this.BusinessList);
      } else {
        this.BusinessList = [];
      }
    },
    async addNew() {
      //确认新增
      if (!this.isEdit) {
        //新增
        if (this.ruleForm.text.length == 0) {
          return this.$message.error("内容不能为空！");
        } else if (this.ruleForm.businessId == "") {
          return this.$message.error("未选择所属行业！");
        } else if (this.ruleForm.title==''){
          return this.$message.error("标题不能为空！");
        }
        //必填项不能为空，否则不能上传
        let param={}
        param.title=this.ruleForm.title
        param.businessId=this.ruleForm.businessId
        param.sort = this.ruleForm.sort
        param.text=encodeURI(this.ruleForm.text + "");
      //  this.ruleForm.text = encodeURI(this.ruleForm.text + "");
        let res = await addIndustry(param);
        if (res.code == 200) {
          this.$message.success("新增行业应用成功！");
          this.ruleForm.text = "";
          this.ruleForm.businessId = "";
          this.$router.replace("/Industry");
        }
      } else {
        //编辑状态
        let param = {};
        param.id = this.editId;
        param.text = encodeURI(this.ruleForm.text + "");
        param.businessId = this.ruleForm.businessId;
        param.sort = this.ruleForm.sort
        param.title=this.ruleForm.title
        let res = await editIndustry(param);
        if (res.code == 200) {
          this.$message.success("编辑成功！");
          this.$router.replace("/Industry");
        }
      }
    },
    cancel() {
      this.$router.replace('/industry')
    },
  },
  computed: {
  	leaveDataNew() {
        return JSON.parse(JSON.stringify(this.ruleForm.sort))//watch监听要求
  	},
 },
  watch: {
    leaveDataNew:{
      handler:function(newVal,oldVal){
        var reg = /^[+]{0,1}(\d+)$/
          if (!reg.test(newVal)&&newVal!='') {
            this.ruleForm.sort = oldVal
          } else {
            this.ruleForm.sort = newVal
          }
      },
      deep:true
    }
  }
};
</script>

<style lang="less" scoped>
#scroll {
  height: 100%;
}
.container {
  padding: 30px;
  background: #fff;
  border: 1px solid #ddd;
  border-radius: 5px;
}
.el-form {
  display: flex;
  flex-wrap: wrap;
}
.el-form .el-input {
  width: 215px;
}
</style>